import { useMutation } from 'react-query';
import { TRegisterChartParams } from 'types/apis/chart/studentEvaluationChart';
import { TCheckSamePatientResponse } from 'types/apis/chart/studentEvaluationChart';
import { postEvaluationChart } from 'apis/chart/studentEvaluationChart';
import { isTCustomAxiosError } from 'apis/config/axios';
import useModal from 'hooks/useModal';
import { TChangePatient } from 'hooks/chart/useCheckChart';

type TProps = {
  registeredChartId: number | undefined;
  courseInfoId: number | undefined;
  patientId: string | undefined;
  chartTypeNum: number | undefined;
  checkData?: TCheckSamePatientResponse | undefined;
  goToChart: (evaluationChartId: number, evaluationRound: number) => void;
  onChangePatient?: ({
    patientId,
    courseInfoId,
    chartTypeNum,
    registeredChartId,
    isError,
    data,
  }: TChangePatient) => void;
};

const useChartCreater = ({
  registeredChartId,
  courseInfoId,
  patientId,
  chartTypeNum,
  checkData,
  goToChart,
  onChangePatient,
}: TProps) => {
  const { modal, openModal, closeModal } = useModal();

  const { mutate: chartCreater } = useMutation(
    (params: TRegisterChartParams) => postEvaluationChart(params),
    {
      onSuccess: ({ data }) => {
        if (!data.evaluationChartId) throw new Error('차트 생성 실패');
        closeModal();
        goToChart(data.evaluationChartId, data.evaluationRound || 0);
      },
      onError: (error) => {
        if (
          isTCustomAxiosError(error) &&
          error.code === 488 &&
          onChangePatient &&
          patientId &&
          courseInfoId &&
          chartTypeNum &&
          registeredChartId &&
          checkData
        ) {
          closeModal();
          patientId &&
            onChangePatient({
              patientId,
              courseInfoId,
              chartTypeNum,
              registeredChartId,
              isError: true,
              data: checkData as TCheckSamePatientResponse,
            });
        } else {
          modal.modalStack.length > 1 && closeModal();
          openModal({
            title: '차트 생성 실패',
            text: '다시 시도해 주세요.',
          });
        }
      },
    }
  );

  return { chartCreater };
};

export default useChartCreater;
